import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const IStatusbarService = ( createDecorator('statusbarService'));
function isStatusbarEntryLocation(thing) {
    const candidate = thing;
    return typeof candidate?.id === 'string' && typeof candidate.alignment === 'number';
}
function isStatusbarEntryPriority(thing) {
    const candidate = thing;
    return (typeof candidate?.primary === 'number' || isStatusbarEntryLocation(candidate?.primary)) && typeof candidate?.secondary === 'number';
}
const ShowTooltipCommand = {
    id: 'statusBar.entry.showTooltip',
    title: ''
};
const StatusbarEntryKinds = ['standard', 'warning', 'error', 'prominent', 'remote', 'offline'];
export { IStatusbarService, ShowTooltipCommand, StatusbarEntryKinds, isStatusbarEntryLocation, isStatusbarEntryPriority };
